import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, TOKEN_KEY, formatApiError } from "@/lib/adminApi";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null=checking, false=guest, obj=logged in

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setAdmin(false);
      return;
    }
    try {
      const { data } = await adminApi.get("/auth/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.access_token);
      setAdmin(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
